import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations, mapState } from 'vuex';
import ApiService from '../../../services/apiService';
import { validImageFileName } from '../../../utils/vuex';
import get from 'lodash/get';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js'; // import { codemirror } from 'vue-codemirror';

import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css'; //import 'codemirror/theme/default.css';

import 'codemirror/mode/markdown/markdown.js';
export default {
  name: 'CoreDtwinEditInformation',
  components: {
    // codemirror,
    MarkdownItVueLight: MarkdownItVueLight
  },
  props: {
    twinObject: {
      type: Object,
      required: true
    },
    account: {
      type: String,
      default: null
    },
    deviceTemplate: {
      type: Object,
      required: false,
      default: null
    },
    hasTwinManagePermission: {
      type: Boolean,
      required: true
    },
    hasTwinEditPermission: {
      type: Boolean,
      required: true
    },
    hasUserReadPermission: {
      type: Boolean,
      required: true
    },
    hasVisibleParent: {
      type: Boolean,
      required: true
    },
    hideFields: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    tagListType: {
      type: String,
      default: 'digitalTwin',
      required: false
    }
  },
  data: function data() {
    return {
      originalTitle: null,
      markdownEdit: false,
      cmOptions: {
        lineWrapping: true,
        tabSize: 4,
        mode: {
          name: 'markdown',
          highlightFormatting: true
        },
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'default',
        line: true,
        lineNumbers: false,
        foldGutter: true,
        styleActiveLine: true,
        styleSelectedText: true,
        hintOptions: {
          completeSingle: false
        }
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions'])), {}, {
    twinCanBeEdited: function twinCanBeEdited() {
      return this.hasTwinEditPermission && !this.dtwinIsDisabled && !this.cloading;
    },
    dtwinIsDisabled: function dtwinIsDisabled() {
      return get(this.twinObject, 'properties.disabled');
    },
    isCreatedByTemplate: function isCreatedByTemplate() {
      return !!this.deviceTemplate;
    },
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }];
    },
    twinTypes: function twinTypes() {
      return [{
        value: 'default',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.types.default')
      }, {
        value: 'building',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.types.building')
      }, {
        value: 'sensor',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.types.sensor')
      }, {
        value: 'room',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.types.room')
      }, {
        value: 'door',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.types.door')
      }, {
        value: 'zone',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.types.zone')
      }, {
        value: 'floor',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.types.floor')
      }, {
        value: 'trackable',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.types.trackable')
      }];
    },
    selectedTwinTypeText: function selectedTwinTypeText() {
      var _this2 = this;

      var descriptiveType = this.twinTypes.find(function (t) {
        return t.value === _this2.twinObject.data.type;
      });

      if (descriptiveType) {
        return descriptiveType.text;
      }

      return this.twinObject.data.type;
    },
    cloading: function cloading() {
      return this.$store.state.app.loading;
    },
    selectedAttachments: function selectedAttachments() {
      if (this.twinObject.data.twinImageId) {
        return [this.twinObject.data.twinImageId];
      }

      return [];
    },
    twinImages: function twinImages() {
      return [{
        name: this.$i18n_t('DigitalTwin.DigitalTwin.states.dataSources.none'),
        id: null
      }].concat((this.twinObject.data && this.twinObject.data.attachments || []).filter(function (attachment) {
        return validImageFileName(attachment.name);
      }));
    },
    scopeDetailledName: function scopeDetailledName() {
      var name = get(this.twinObject, 'scope.name');
      var id = get(this.twinObject, 'scope.id') || get(this.twinObject, 'scopeId');

      if (id !== undefined) {
        return "".concat(name, " (ID ").concat(id, ")");
      }

      return name;
    }
  }),
  watch: {
    twinObject: function twinObject() {
      this.initialMetaDataSetup();
    }
  },
  created: function created() {
    this.initialMetaDataSetup();
  },
  mounted: function mounted() {},
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['snackbar'])), {}, {
    get: get,
    initialMetaDataSetup: function initialMetaDataSetup() {
      this.originalTitle = get(this.twinObject, 'title');

      if (!this.twinObject.data) {
        this.twinObject.data = {};
      }
    },
    userRelationsUpdated: function userRelationsUpdated(data) {
      this.twinObject.data.userRelations = data;
    },
    attachmentsUpdated: function attachmentsUpdated(data) {
      this.twinObject.data.attachments = data;
    },
    twinImageSelected: function twinImageSelected(item) {
      this.twinObject.data.twinImageId = item.id;
    },
    twinImageDeselected: function twinImageDeselected() {
      delete this.twinObject.data.twinImageId;
    },
    parentSelectorFilter: function parentSelectorFilter(item, parentList) {
      var _this3 = this;

      return (// only allow new parents from the same tenant
        item.tenantId === this.twinObject.tenantId && // obviously cannot select this twin as its own parent
        item.id !== this.twinObject.id && // and it should not be a descendent of this twin
        parentList.findIndex(function (t) {
          return t.id === _this3.twinObject.id;
        }) === -1
      );
    },
    setTags: function setTags(a) {
      this.twinObject.data.tags = a.tags;
    },
    createDigitalTwinScope: function createDigitalTwinScope() {
      var _this4 = this;

      ApiService.digitalTwinCreateScope(this, this.twinObject.id).then(function () {
        _this4.$snack(_this4.$i18n_t('DigitalTwin.DigitalTwin.twinScopeCreationSuccessSnack'), 'success');

        _this4.$emit('scope-updated');
      }).catch(function (error) {
        if (error.response && _this4.$i18n_t("Error.".concat(error.response.data.message))) {
          _this4.$snack(_this4.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this4.$snack(_this4.$i18n_t('DigitalTwin.DigitalTwin.twinScopeCreationFailedSnack'), 'error');
        }
      });
    }
  })
};